import React from 'react';

const DrAeshaApproachBanner = () => {
  return (
    <div className="bg-teal-700 py-20">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-4xl md:text-5xl font-serif text-white mb-8">
          Dr. Aesha's approach to dentistry
        </h2>
        
        <p className="text-white/90 text-lg leading-relaxed">
          Dr. Aesha believes that effective dental care begins with understanding and addressing each patient's unique needs. She takes the time to listen to her patients and ensure they feel comfortable and informed throughout their treatment. By fostering a friendly and trusting environment, Dr. Aesha helps her patients achieve optimal dental health and confidence in their smiles.
        </p>
      </div>
    </div>
  );
};

export default DrAeshaApproachBanner;